/* Bodysuit PDP — gallery, before/after slider, variant picker (color + size) */
(function () {
  function blInit() {
  // ---- gallery ----
  document.querySelectorAll('[data-bl-gallery]').forEach(function (g) {
    var shots = g.querySelectorAll('.bl-shot');
    var thumbs = g.querySelectorAll('.bl-thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-i');
        shots.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-i') === i); });
        thumbs.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });
    // swipe left/right on the main image to move through shots
    var stage = g.querySelector('.bl-stage');
    if (stage && shots.length > 1) {
      var sx = 0, sy = 0;
      stage.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        var cur = 0;
        shots.forEach(function (s, i) { if (s.classList.contains('on')) cur = i; });
        var n = (cur + (dx < 0 ? 1 : -1) + shots.length) % shots.length;
        shots.forEach(function (s, i) { s.classList.toggle('on', i === n); });
        thumbs.forEach(function (t, i) { t.classList.toggle('on', i === n); });
      }, { passive: true });
    }
  });

  // ---- before / after slider ----
  document.querySelectorAll('[data-bl-ba]').forEach(function (ba) {
    var before = ba.querySelector('.before');
    var handle = ba.querySelector('.handle');
    if (!before || !handle) return;
    var drag = false;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = Math.max(.04, Math.min(.96, (x - r.left) / r.width));
      before.style.width = (p * 100) + '%';
      handle.style.left = (p * 100) + '%';
    }
    function startDrag(e) { drag = true; if (e.cancelable) e.preventDefault(); }
    function moveDrag(e) { if (!drag) return; if (e.cancelable) e.preventDefault(); var x = e.touches ? e.touches[0].clientX : e.clientX; set(x); }
    function endDrag() { drag = false; }
    handle.addEventListener('mousedown', startDrag);
    handle.addEventListener('touchstart', startDrag, { passive: false });
    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('touchmove', moveDrag, { passive: false });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);
    ba.addEventListener('click', function (e) { set(e.clientX); });
  });

  // ---- variant picker ----
  document.querySelectorAll('[data-bl-buybox]').forEach(function (root) {
    var dataEl = root.querySelector('[data-bl-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-bl-id]');
    var nowEl = root.querySelector('[data-bl-now]');
    var wasEl = root.querySelector('[data-bl-was]');
    var atc = root.querySelector('.bl-atc');
    var colorBtns = root.querySelectorAll('[data-bl-color]');
    var sizeBtns = root.querySelectorAll('[data-bl-size]');
    var colorLabel = root.querySelector('[data-bl-color-label]');
    var sizeLabel = root.querySelector('[data-bl-size-label]');
    var hasColor = colorBtns.length > 0;

    function selectedColor() { var b = root.querySelector('[data-bl-color].on'); return b ? b.getAttribute('data-bl-color') : null; }
    function selectedSize() { var b = root.querySelector('[data-bl-size].on'); return b ? b.getAttribute('data-bl-size') : null; }

    function findVariant(c, s) {
      return variants.find(function (v) {
        var okC = !hasColor || v.o1 === c;
        return okC && (v.o2 === s || v.o1 === s);
      }) || variants.find(function (v) { return (v.o1 === s || v.o2 === s); });
    }
    function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

    function update() {
      var c = selectedColor(), s = selectedSize();
      var v = findVariant(c, s);
      if (colorLabel && c) colorLabel.textContent = c;
      if (sizeLabel && s) sizeLabel.textContent = s;
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (nowEl) nowEl.textContent = money(v.price);
      if (wasEl) { if (v.compare > v.price) { wasEl.textContent = money(v.compare); wasEl.style.display = ''; } else { wasEl.style.display = 'none'; } }
      if (atc) {
        atc.disabled = !v.available;
        atc.querySelector('[data-bl-atc-label]').textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
      // mark unavailable sizes for the chosen color
      sizeBtns.forEach(function (sb) {
        var sv = findVariant(c, sb.getAttribute('data-bl-size'));
        sb.disabled = sv ? !sv.available : false;
      });
    }
    colorBtns.forEach(function (b) { b.addEventListener('click', function () { colorBtns.forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); update(); }); });
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; sizeBtns.forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); update(); }); });
    update();
  });

  // ---- find-my-size quiz ----
  var CANON = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  document.querySelectorAll('[data-bl-quiz]').forEach(function (quiz) {
    var buybox = quiz.closest('[data-bl-buybox]');
    var openBtns = [].slice.call(document.querySelectorAll('[data-bl-quiz-open]'));
    var body = quiz.querySelector('[data-bl-quiz-body]');
    var bar = quiz.querySelector('[data-bl-quiz-bar]');

    // parse config
    var map = {}, bands = [];
    (quiz.dataset.sizemap || '').split(/\r?\n/).forEach(function (ln) {
      var m = ln.split('='); if (m.length === 2) { var b = m[0].trim(), s = m[1].trim(); if (b && s) { map[b] = s; bands.push(b); } }
    });
    var cups = (quiz.dataset.cups || 'A,B,C,D,DD,E/F').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    var fits = (quiz.dataset.fits || '').split(/\r?\n/).map(function (ln) {
      var p = ln.split('|'); if (p.length < 2) return null;
      return { label: p[0].trim(), sub: p[1].trim(), adj: parseInt(p[2], 10) || 0 };
    }).filter(Boolean);
    if (!fits.length) fits = [
      { label: 'Light & comfy', sub: 'Relaxed, everyday wear', adj: 1 },
      { label: 'Firm — recommended', sub: 'True-to-size sculpting', adj: 0 },
      { label: 'Maximum sculpt', sub: 'Snug, extra hold', adj: 0 }
    ];

    var sizeBtns = buybox ? [].slice.call(buybox.querySelectorAll('[data-bl-size]')) : [];
    var prodSizes = sizeBtns.map(function (b) { return b.getAttribute('data-bl-size'); });
    var steps = ['band', 'cup', 'fit', 'result'];
    var answers, step;

    function reset() { answers = { band: null, cup: null, cupIdx: 0, fit: 0, fitI: -1 }; step = 0; }
    function canonIdx(label) { var i = CANON.indexOf((label || '').toUpperCase()); return i < 0 ? CANON.indexOf('M') : i; }

    function recommend() {
      var base = map[answers.band] || 'M';
      var idx = canonIdx(base);
      var cupBump = answers.cupIdx >= (cups.length - 2) ? 1 : 0;
      idx = Math.max(0, Math.min(CANON.length - 1, idx + cupBump + answers.fit));
      var target = CANON[idx];
      var exact = prodSizes.find(function (s) { return s.toUpperCase() === target; });
      if (exact) return exact;
      var best = null, bestD = 99;
      prodSizes.forEach(function (s) { var d = Math.abs(canonIdx(s) - idx); if (d < bestD) { bestD = d; best = s; } });
      return best || target;
    }
    function opt(html, on) { return '<button type="button" class="bl-quiz-opt' + (on ? ' on' : '') + '">' + html + '</button>'; }

    function render() {
      if (bar) bar.style.width = (step / (steps.length - 1)) * 100 + '%';
      var kind = steps[step];
      if (kind === 'band') {
        body.innerHTML = '<p class="bl-quiz-q">1 &middot; ' + (quiz.dataset.q1 || 'Your usual bra band size') + '</p><div class="bl-quiz-grid">' +
          bands.map(function (b) { return opt('<b>' + b + '</b>', answers.band === b); }).join('') +
          '</div><p class="bl-quiz-help">' + (quiz.dataset.q1help || 'The number in your bra size — e.g. the 34 in 34C.') + '</p>';
        body.querySelectorAll('.bl-quiz-opt').forEach(function (b, i) { b.onclick = function () { answers.band = bands[i]; next(); }; });
      } else if (kind === 'cup') {
        body.innerHTML = '<p class="bl-quiz-q">2 &middot; ' + (quiz.dataset.q2 || 'Your cup size') + '</p><div class="bl-quiz-grid">' +
          cups.map(function (c, i) { return opt('<b>' + c + '</b>', answers.cup === c); }).join('') +
          '</div><p class="bl-quiz-help">' + (quiz.dataset.q2help || 'The letter in your bra size — e.g. the C in 34C.') + '</p>';
        body.querySelectorAll('.bl-quiz-opt').forEach(function (b, i) { b.onclick = function () { answers.cup = cups[i]; answers.cupIdx = i; next(); }; });
      } else if (kind === 'fit') {
        body.innerHTML = '<p class="bl-quiz-q">3 &middot; How do you like it to feel?</p><div class="bl-quiz-col">' +
          fits.map(function (f, i) { return opt('<b>' + f.label + '</b><span>' + f.sub + '</span>', answers.fitI === i); }).join('') +
          '</div>';
        body.querySelectorAll('.bl-quiz-opt').forEach(function (b, i) { b.onclick = function () { answers.fit = fits[i].adj; answers.fitI = i; next(); }; });
      } else {
        var rec = recommend();
        if (bar) bar.style.width = '100%';
        body.innerHTML = '<div class="bl-quiz-res">' +
          '<p class="bl-quiz-reslbl">Your recommended size</p>' +
          '<div class="bl-quiz-size">' + rec + '</div>' +
          (quiz.dataset.note ? '<p class="bl-quiz-note">' + quiz.dataset.note + '</p>' : '') +
          '<button type="button" class="bl-quiz-pick">Select ' + rec + ' &amp; continue</button>' +
          '<button type="button" class="bl-quiz-restart">Start over</button>' +
          '</div>';
        body.querySelector('.bl-quiz-pick').onclick = function () { pick(rec); };
        body.querySelector('.bl-quiz-restart').onclick = function () { reset(); render(); };
      }
    }
    function next() { if (step < steps.length - 1) { step++; render(); } }
    function pick(size) {
      var btn = sizeBtns.find(function (b) { return b.getAttribute('data-bl-size').toUpperCase() === size.toUpperCase(); });
      if (btn && !btn.disabled) {
        btn.click();
      } else {
        // no theme size buttons (e.g. a bundle app renders <select>) — drive every matching dropdown instead
        [].slice.call(document.querySelectorAll('select')).forEach(function (sel) {
          var match = [].slice.call(sel.options).find(function (o) {
            return (o.textContent || '').trim().toUpperCase() === size.toUpperCase();
          });
          if (match) {
            sel.value = match.value;
            sel.dispatchEvent(new Event('input', { bubbles: true }));
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      close();
      if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function open() { reset(); render(); quiz.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function close() { quiz.hidden = true; document.documentElement.style.overflow = ''; }

    openBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    quiz.querySelectorAll('[data-bl-quiz-close]').forEach(function (x) { x.addEventListener('click', close); });
    quiz.addEventListener('click', function (e) { if (e.target === quiz) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !quiz.hidden) close(); });
  });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', blInit); } else { blInit(); }
})();
